import $ from 'jquery';
import * as Hammer from 'hammerjs';

import { onClickPrev, onClickNext, onResize } from './handlers';
import {
	getControlEls,
	getPPP,
	getSlidesContainer,
	setSlidesWidthAndHeight,
	shouldRepeat,
} from './utils';
import state from './state';

export function addResizeHandlers(slider) {
	$(window).on('resize', function () {
		onResize(slider);
	});
	onResize(slider);
}
export function removeResizeHandlers(slider) {
	$(window).off('resize', function () {
		onResize(slider);
	});
}

export function addCtrlsHandlers(slider) {
	const { controlLeft, controlRight } = getControlEls(slider);
	controlLeft.on('click', onClickPrev);
	controlRight.on('click', onClickNext);

	// Need to pass node to Hammer
	const slidesContainers = getSlidesContainer(slider);
	if (slidesContainers && slidesContainers.length) {
		const hammerSlider = new Hammer(slidesContainers[0]);

		hammerSlider.on('swipeleft', function () {
			controlRight.trigger('click');
		});
		hammerSlider.on('swiperight', function () {
			controlLeft.trigger('click');
		});
	}
}
export function removeCtrlsHandlers(slider) {
	const { controlLeft, controlRight } = getControlEls(slider);
	controlLeft.off('click', onClickPrev);
	controlRight.off('click', onClickNext);
}

export function addListeners(slider) {
	addResizeHandlers(slider);
	addCtrlsHandlers(slider);
	addPerPageAttrListener(slider);

	const sliderId = $(slider).attr('id');

	state.subscribe(sliderId, 'queriedIds', (qids) => {
		shouldRepeat(slider);
	});
}

// For editor side
export function addPerPageAttrListener(slider) {
	const getClassDiff = function (oldStr, newStr) {
		const oldCls = oldStr.split(' ');
		const newCls = newStr.split(' ');
		const result = [];

		// Find words that are in s2 but not in s1
		for (const word of newCls) {
			if (!oldCls.includes(word)) {
				result.push(word);
			}
		}

		return result;
	};

	const sliderId = $(slider).attr('id');

	let prevClass = $(slider).attr('class');
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.attributeName !== 'class') return;

			const newClass = mutation.target.className;
			const diff = getClassDiff(prevClass, newClass);
			if (diff.length) {
				prevClass = mutation.target.className;
				const perPageDiff = diff.filter(
					(d) => d.indexOf('per-page') !== -1
				);
				if (perPageDiff.length) {
					const ppp = getPPP(sliderId);
					const displayLayout = state.get(sliderId, 'displayLayout');

					state.set(sliderId, 'displayLayout', {
						...displayLayout,
						slidesPerPage: ppp,
					});
					setSlidesWidthAndHeight(sliderId);
				}
			}
		});
	});

	const target = $('#' + sliderId).get(0);

	// MDN documentation
	// https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/observe#attributefilter
	observer.observe(target, {
		attributes: true,
		attributeFilter: ['class'],
	});
}

export function removeListeners(slider) {
	removeResizeHandlers(slider);
	removeCtrlsHandlers(slider);
}
